
export default [
    {
        path:'/activityList',
        name:'activityList',
        component: () => import('@/page/activity/activityList')
    },
    {
      path:'/activityDetail',
      name:'activityDetail',
      component: () => import('@/page/activity/activityDetail')
    },
    {
      path:'/activity-upload',
      name:'activity-upload',
      component: () => import('@/page/activity/activity-upload')
    },

]